/* eslint-disable */
import session from './session';

export default {
    getControlUnitList(filter) {
        return session.get(`control_unit/${filter}`);
    },
    getControlUnit(id) {
        return session.get(`control_unit/${id}/`);
    },
    deleteControlUnit(id) {
        return session.delete(`control_unit/${id}/`);
    },
    createControlUnit(data) {
        return session.post(`control_unit/`, data);
    },
    updateControlUnit(id, data) {
        return session.patch(`control_unit/${id}/`, data );
    },
};